import React from 'react';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';
import { TAB_IDS } from '../constants/invoiceTabs';

const DealerInvoiceFilters = ({
    filterFields,
    handleApplyFilters,
    handleResetFilters,
    activeTabId
}) => {
    const initiallyOpen = activeTabId === TAB_IDS.SAP_RECORDS;

    return (
        <div className="mb-3">
            <GenericTableFilter
                filterFields={filterFields}
                columns={[]}
                initialFilters={{}}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
                initiallyOpen={initiallyOpen}
            />
        </div>
    );
};

export default DealerInvoiceFilters;
